import React, { useContext, useState} from 'react';
import * as PropTypes from 'prop-types';

import Icon from '@components/icon';
import Link from '@components/link';
import {DataContext} from 'contexts';
import { eventMetrics } from 'logic/requestParams';
import {useLocalized} from 'utils/useLocalized';

import BoardsPopoverContainer from 'components/Page/SearchResults/BoardsPopoverContainer';
import ScrollsPopoverContainer from 'components/Page/SearchResults/ScrollsPopoverContainer';
import FirmInfo from 'components/Page/SearchResults/FirmInfo';
import i18nStrings from './strings';
import styles from './styles.modules.scss';
import Contacts from 'components/Page/SearchResults/Contacts';

const FirmCard = ({id, firm, icons}) => {
    const { writeEvent } = useContext(DataContext);
    const strings = useLocalized(i18nStrings);

    const [boardsPopoverVisible, setBoardsPopoverVisible] = useState(false);
    const [scrollsPopoverVisible, setScrollsPopoverVisible] = useState(false);

    return (
        <div className={styles['firm-card']}>
            <FirmInfo
                firm={firm}
                icons={icons}
                id={id}
            />
	        <div className={styles['contacts']}>
		        <Contacts firmId={id}/>
	        </div>
            <div className={styles['actions']}>
                <div className={styles['boards']}>
                    <BoardsPopoverContainer
                        atiIds={[id]}
                        visible={boardsPopoverVisible}
                        onPopoverVisibleChange={setBoardsPopoverVisible}
                    >
                        <Link
                            onClick={() => writeEvent(eventMetrics.openInviteToBoards, [id])}
                        >
                            <div className={styles['action']}>
                                <Icon
                                    color="#478CC8"
                                    height={16}
                                    name="ic_plus-solid"
                                    width={16}
                                />
                                <span>
                                    {strings.inviteToBoards}
                                </span>
                            </div>
                        </Link>
                    </BoardsPopoverContainer>
                </div>
                <div className={styles['scrolls']}>
                    <ScrollsPopoverContainer
                        atiIds={[id]}
                        visible={scrollsPopoverVisible}
                        onPopoverVisibleChange={setScrollsPopoverVisible}
                    >
                        <Link
                            onClick={() => writeEvent(eventMetrics.openAddToList, [id])}
                        >
                            <div className={styles['action']}>
                                <Icon
                                    color="#478CC8"
                                    height={16}
                                    name="ic_plus-solid"
                                    width={16}
                                />
                                <span>
                                    {strings.inviteToScrolls}
                                </span>
                            </div>
                        </Link>
                    </ScrollsPopoverContainer>
                </div>
            </div>
        </div>
    );
};

export default FirmCard;

FirmCard.propTypes = {
    firm: PropTypes.object,
    icons: PropTypes.object,
    id: PropTypes.string
};
